module.exports = __webpack_public_path__ + "static/media/videoCall.edcc9fa.mp3";


//////////////////
// WEBPACK FOOTER
// ./static/media/videoCall.mp3
// module id = 3m+7
// module chunks = 1